import Vue from 'vue'
import {getWithPagination, ProjectsResource} from '../../util/api'

const initialState = {
  objects: {},
  creatingObject: null, // The object currently being created
  editingObject: null, // The Object currently being editing
  createdObject: null, // The most recent Object to be created
  updatedObject: null, // The most recent Object to be updatd
  getInProgress: false, // Is a GET request in progress for this Store?
  createInProgress: false, // Is a GET request in progress for this Store?
  updateInProgress: false, // Is a POST or PUT request in progress for this Store?
  deleteInProgress: false // Is a DELETE request in progress for this Store?
}

export default {
  state: { ...initialState },
  mutations: {
    SET_PROJECTS (state, objects) {
      let updatedObjects = {}
      for (let key in objects) {
        if (objects.hasOwnProperty(key)) {
          if (objects[key].deleted_at === null) {
            // Stage the update so we can just do one Vue.set
            updatedObjects[objects[key].id] = objects[key]
          } else if (state.objects.hasOwnProperty(objects[key].id)) {
            // Immediately delete the object
            Vue.delete(state.objects, objects[key].id)
          }
        }
      }
      state.objects = {
        ...state.objects,
        ...updatedObjects
      }
    },
    SET_PROJECT (state, object) {
      if (object.deleted_at === null) {
        Vue.set(state.objects, object.id, object)
      } else {
        Vue.delete(state.objects, object.id)
      }
    },
    CREATING_PROJECT (state, object) {
      state.creatingObject = object
    },
    EDITING_PROJECT (state, object) {
      state.editingObject = object
    },
    CREATED_PROJECT (state, object) {
      state.createdObject = object
    },
    UPDATED_PROJECT (state, object) {
      state.updatedObject = object
    },

    // Progress States
    GET_PROJECT_IN_PROGRESS (state, value) {
      state.getInProgress = value
    },
    CREATE_PROJECT_IN_PROGRESS (state, value) {
      state.createInProgress = value
    },
    UPDATE_PROJECT_IN_PROGRESS (state, value) {
      state.updateInProgress = value
    },
    DELETE_PROJECT_IN_PROGRESS (state, value) {
      state.deleteInProgress = value
    },

    PROJECTS_CLEAR_ALL (state) {
      for (let key in initialState) {
        Vue.set(state, key, initialState[key])
      }
    }
  },

  actions: {
    getProject ({ commit }, id) {
      // Check if we have an up-to-date version of the object. If not, get it.
      try {
        commit('GET_PROJECT_IN_PROGRESS', true)
        ProjectsResource.get({id: id}).then((response) => {
          commit('GET_PROJECT_IN_PROGRESS', false)
          commit('SET_PROJECT', response.body)
        }, () => {
          commit('GET_PROJECT_IN_PROGRESS', false)
          // @TODO: Implement error handling
        })
      } catch (ex) {
        // Request was most likely cancelled due to existing in flight request
        commit('GET_PROJECT_IN_PROGRESS', false)
      }
    },

    getProjects ({ commit }, params) {
      // Download all Projects
      commit('GET_PROJECT_IN_PROGRESS', true)
      getWithPagination(ProjectsResource, params, response => {
        // Note: Pagination requests return the objects under the 'data' key
        commit('SET_PROJECTS', response.body.data)
      }, () => {
        // Completion handler
        commit('GET_PROJECT_IN_PROGRESS', false)
      }, () => {
        // Error handler
        commit('GET_PROJECT_IN_PROGRESS', false)
      })
    },

    createProject ({ commit }, object) {
      // Create (POST) a Project
      commit('CREATED_PROJECT', null)
      commit('CREATE_PROJECT_IN_PROGRESS', true)
      ProjectsResource.save({}, object).then((response) => {
        commit('CREATE_PROJECT_IN_PROGRESS', false)
        commit('CREATED_PROJECT', response.body)
        commit('SET_PROJECT', response.body)
      }, () => {
        console.error('Create Project Failed')
        commit('CREATE_PROJECT_IN_PROGRESS', false)
        commit('CREATED_PROJECT', null)
      })
    },

    updateProject ({ commit }, object) {
      // Update (PUT) a Project
      commit('UPDATED_PROJECT', null)
      commit('UPDATE_PROJECT_IN_PROGRESS', true)
      ProjectsResource.update({id: object.id}, object).then((response) => {
        commit('UPDATE_PROJECT_IN_PROGRESS', false)
        commit('UPDATED_PROJECT', response.body)
        commit('SET_PROJECT', response.body)
      }, () => {
        commit('UPDATE_PROJECT_IN_PROGRESS', false)
        commit('UPDATED_PROJECT', null)
      })
    },
    creatingProject ({ commit }, object) {
      // Set the currently in-edit Project
      commit('CREATING_PROJECT', object)
    },
    editingProject ({  commit }, object) {
      // Set the currently in-edit Project
      commit('EDITING_PROJECT', object)
    },

    clearAll ({ commit }) {
      commit('PROJECTS_CLEAR_ALL')
    }
  }
}
